import { FilterBuilderPopup as DxFilterBuilderPopup } from "devextreme-react/data-grid";
import React from "react";
const filterBuilderPopupPosition = {
    of: window,
    at: "top",
    my: "top",
    offset: { y: 60 }
};
export default function FilterBuilderPopup() {
    return React.createElement(DxFilterBuilderPopup, { position: filterBuilderPopupPosition });
}
